export const FeatureCategoryNameEnum = {
    COWORKINGS: 'COWORKINGS',
    MOBILITY: 'MOBILITY',
    PROFESSIONAL_DEVELOPMENT: 'PROFESSIONAL_DEVELOPMENT',
    ANALYTICS: 'ANALYTICS',
    FLEX: 'FLEX',
};
